@if (isLoading) {
  <div class="loader-container">
    <span class="loader"></span>
  </div>
}
<div class="content-wrapper">
  <div>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
